export const cols = [{
	prop: 'customercode',
	label: '客户编号',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customername',
	label: '客户名称',
	width: '120',
	ischoose: true,
	align: 'center'
}, {
	prop: 'customercategoryname',
	label: '客户类别',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'number',
	label: '单据编号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentdate',
	label: '支付时间',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentmode',
	label: '支付方式',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentmoney',
	label: '支付金额（元）',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'payeeAccountNo',
	label: '收款主体商编',
	width: '200',
	ischoose: false,
	align: 'center'
}, {
	prop: 'paymentnumber',
	label: '第三方支付平台流水号',
	width: '200',
	ischoose: false,
	align: 'center'
}, {
	prop: 'paymentserialnumber',
	label: '极速订支付流水号',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundapplydate',
	label: '退款申请时间',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundoverdate',
	label: '退单完成时间',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundpaymentdate',
	label: '退款完成时间',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundmoney',
	label: '退款金额',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundpaymentnumber',
	label: '退款流水号',
	width: '180',
	ischoose: true,
	align: 'center'
}, {
	prop: 'ordernumber',
	label: '关联下单订单号',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundpaymentmode',
	label: '退款方式',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'refundtype',
	label: '退款类型',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'memo',
	label: '备注',
	width: '160',
	ischoose: true,
	align: 'center'
}, {
	prop: 'paymentordernumber',
	label: '订单支付流水号',
	width: '200',
	ischoose: true,
	align: 'center'
}, {
	prop: 'payAccountNo',
	label: '退款付款商编',
	width: '200',
	ischoose: true,
	align: 'center'
}]
